export enum DonationInKindTypes {
  DonatedFacilitiesAndServices = 1,
  DonatedGoodsAndServicesCapitalisedAsTangibleFixedAssets = 2,
  DonatedGoodsForDistributionToBeneficiaries = 3,
  DonatedGoodsForResale = 4,
}
